import { prop,propObject,propArray,required,maxLength,range  } from "@rxweb/reactive-form-validators"
import { gridColumn } from "@rxweb/grid"


export class ContractAttachmentBase {

//#region contractAttachmentId Prop
        @prop()
        contractAttachmentId : number;
//#endregion contractAttachmentId Prop


//#region contractId Prop
        @range({minimumNumber:1,maximumNumber:2147483647})
        @required()
        contractId : number;
//#endregion contractId Prop


//#region attachment Prop
        @maxLength({value:500})
        attachment : string;
//#endregion attachment Prop


//#region attachmentURL Prop
        @prop()
        attachmentURL : string;
//#endregion attachmentURL Prop


//#region attachmentSize Prop
        @prop()
        attachmentSize : number;
//#endregion attachmentSize Prop


//#region createdBy Prop
        @prop()
        createdBy : number;
//#endregion createdBy Prop


//#region createdOn Prop
        @prop()
        createdOn : any;
//#endregion createdOn Prop



}